import type { ReactNode } from 'react';
import { AppErrorBoundary } from '../app-error-boundary';
import type { AppRuntime } from '../runtime';
import { I18nProvider } from './i18n-provider';
import { QueryProvider } from './query-provider';
import { RealtimeProvider } from './realtime-provider';
import { RuntimeProvider } from './runtime-provider';
import { SessionProvider } from './session-provider';
import { ThemeProvider } from './theme-provider';

/**
 * The provider stack of docs/plan/12-frontend.md section 1:
 * I18n > Theme > Query > Session > Realtime > (Router). The runtime context sits above it so
 * every provider reads the same long-lived objects, and the error boundary sits inside the theme
 * so its page is translated and styled.
 */
export function AppProviders({ runtime, children }: { runtime: AppRuntime; children?: ReactNode }) {
  return (
    <RuntimeProvider runtime={runtime}>
      <I18nProvider>
        <ThemeProvider>
          <AppErrorBoundary runtime={runtime}>
            <QueryProvider>
              <SessionProvider>
                <RealtimeProvider>{children}</RealtimeProvider>
              </SessionProvider>
            </QueryProvider>
          </AppErrorBoundary>
        </ThemeProvider>
      </I18nProvider>
    </RuntimeProvider>
  );
}
